import {
  booleanAttribute,
  Component,
  inject,
  input,
  OnInit,
  signal
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { PlatformService } from '@core/services/platform.service';
import { ScreenService } from '@core/services/screen.service';

import {
  MenuItem,
  SidebarMenuComponent
} from '@shared/components/sidebar-menu/sidebar-menu.component';

const MOBILE_BREAKPOINT = 1024;

@Component({
  selector: 'mw-sidebar-page-layout',
  standalone: true,
  imports: [SidebarMenuComponent],
  templateUrl: './sidebar-page-layout.component.html',
  styleUrl: './sidebar-page-layout.component.scss',
  host: {
    '[class.fixed-height]': 'fixedHeight()'
  }
})
export class SidebarPageLayoutComponent implements OnInit {
  private readonly platform = inject(PlatformService);
  private readonly screenService = inject(ScreenService);

  readonly menuItems = input.required<MenuItem[]>();
  /** Caps the projected content to the available height instead of letting it grow. */
  readonly fixedHeight = input(false, { transform: booleanAttribute });
  readonly sidebarExpanded = signal(false);

  constructor() {
    if (this.platform.isPlatformBrowser) {
      this.screenService
        .onResize$({ breakpoint: MOBILE_BREAKPOINT })
        .pipe(takeUntilDestroyed())
        .subscribe(({ isMobile }) => {
          this.sidebarExpanded.set(!isMobile);
        });
    }
  }

  ngOnInit(): void {
    if (this.platform.isPlatformBrowser) {
      const isInitialMobileScreen =
        this.screenService.isMobileDevice(MOBILE_BREAKPOINT);
      this.sidebarExpanded.set(!isInitialMobileScreen);
    }
  }

  toggleSidebar(): void {
    this.sidebarExpanded.update((value) => !value);
  }
}
